// 公共函数
// @desc 公共函数文件
// @author ss
// @date 随时更新
// @example this.$zj.函数名
import Vue from 'vue';
import common from "./common";
import dialog from "../../components/common-dialog";
import loadDom from "../../components/loading";
class Training {
  quickSort(arr, type) {    //快速排序
    //参数1 要排序的数据
    //参数2 0 正序  1 倒序
    if (arr.length <= 1) { return arr; }
    var pivotIndex = Math.floor(arr.length / 2);
    var pivot = arr.splice(pivotIndex, 1)[0];
    var left = [];
    var right = [];
    for (var i = 0; i < arr.length; i++) {
      if (type == 1) {
        if (arr[i] >= pivot) {
          left.push(arr[i]);
        }
        else {
          right.push(arr[i]);
        }
      } else {
        if (arr[i] <= pivot) {
          left.push(arr[i]);
        }
        else {
          right.push(arr[i]);
        }
      }

    }
    return this.quickSort(left, type).concat([pivot], this.quickSort(right, type));
  }
  ArrayGroup(obj, title) {  //过滤空数组
    //参数1 要排序的数据
    //参数2 排序的数据所对应的名称
    for (let i = 0; obj[i] != undefined; i++) {
      if (obj[i].length <= 0) {
        obj.splice(i, 1);
        title.splice(i, 1);
        --i;
      }
    }
    return "[" + this.strAllsorts(obj, title);
  }

  strAllsorts(obj, title, l, value, parent = [], type) {    //全排列
    let length = l == undefined ? 0 : ++l;
    let str = "";
    if (obj[length] != undefined) {
      for (let i = 0; obj[length][i] != undefined; i++) {
        if (length == obj.length - 1) {
          parent.push(obj[length][i]);
          let std = "";
          std = "{";
          for (let j = 0; title[j] != undefined; j++) {
            std += `"${title[j]}":${JSON.stringify(parent[j])},`;
          }
          std = std.substr(0, std.length - 1);
          str += std + "},";
          parent.pop();
        } else if (length == 0) {
          parent = [];
          parent.push(obj[length][i]);
          str += this.strAllsorts(obj, title, length, obj[length][i], parent, 0);
        } else {
          parent.push(obj[length][i]);
          str += this.strAllsorts(obj, title, length, obj[length][i], parent, 0);
          parent.pop();
        }
      }
      if (type != undefined) return str;
    }
    return str.substr(0, str.length - 1) + "]";
  }
  tree(data, logic, name) {  //树形结构解析
    //参数1 要解析的数据
    //参数2 设定条件 [{id:'在对象中的子值',pid:'在对象中的父值',emptyValue:"没有父及填写的值 不填默认为null"}]
    //参数3 子对象名称 不填为children
    let data1 = [];
    return common.treeAnalysis(data, logic, 2, name, data1, 1);
  }
  equal(time, time1) {    //等比例换算
    //参数1 视频 或 音乐 全长
    //参数2 当前播放时间
    //return 当前播放到达整体视频的百分比值x
    let timer = time / 100;
    return parseInt(time1 / timer);
  }
  floatExact(arr, carry) {
    //参数1 要计算的小数 可以是多个  Array
    //参数2 + || -
    let value = arr[0];
    for (let i = 1; arr[i] != undefined; i++) {
      switch (carry) {
        case "+":
          value = parseFloat(value) * 10 + parseFloat(arr[i]) * 10;
          value /= 10;
          break;
        case "-":
          value = parseFloat(value) * 10 - parseFloat(arr[i]) * 10;
          value /= 10;
      }
    }
    return value;
  }
  curve(el, left, top, time) {
    //参数1 元素
    //参数2 left坐标
    //参数3 top坐标
    //参数4 抛物速度 毫秒
    //第二个坐标和第三个坐标默认为0
    time = time / 1000;
    el.style.top = el.pageY == undefined ? 1 + 'px' : el.pageY + 'px';
    el.style.left = el.pageX == undefined ? 1 + 'px' : el.pageY + 'px';
    el.style.transition = `left ${time}s linear, top ${time}s linear`
    setTimeout(() => {
      el.style.top = top == undefined ? window.innerHeight + 'px' : top + 'px';
      el.style.left = left == undefined ? '0px' : left + 'px';
    }, 20)
    setTimeout(() => {
      el.remove();
    }, time * 1000)
  }
  character(str, length) {    //字符长度限制
    let data = common.getCharacterLength(str, length);
    if (data.w <= length) {
      return {
        str: data.content,
        whether: false
      }
    } else {
      return {
        str: data.content,
        whether: true
      }
    }
  }
  card(card) { //身份证号验证
    if (/^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/.test(card)) {
      return true;
    } else {
      return false;
    }
  }
  phome(phome) {   //手机号验证
    if (/^1[3,9]{1}[0-9]\d{8}$/.test(phome)) {
      return true;
    } else {
      return false;
    }
  }
  characterLength(str) {   //读取字符长度
    return common.getCharacterLength(str).length;
  }
  isMepty(str) {  //非空验证
    let type;
    let mepty = false;
    if (typeof str == "string") { //空字符串
      type = "String";
      if (str.replace(/\s/g, "") == "") {
        mepty = true;
      }
    } else if (str instanceof Array) { //空数组
      type = 'Array'
      if (str.length <= 0) {
        mepty = true;
      }
    } else if (str instanceof Object) {    //空对象
      type = "Object";
      let i = 0;
      for (let item in str) {
        i++;
      }
      if (i == 0) mepty = true;
    }
    return {
      type,
      mepty
    }
  }
  custom(str, rpg) {    //自定义验证  预验证数据    正则
    if (rpg.test(str)) {
      return true;
    } else {
      return false;
    }
  }
  mail(str) { //邮箱
    if (/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(str)) {
      return true;
    } else {
      return false;
    }
  }
  webUrl(str) {   //验证网址
    if (/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/.test(str)) {
      return true;
    } else {
      return false;
    }
  }
  card_fete(str) {    //身份证号获取出生日期
    let birthday = "";
    if (str.length == 15) {
      birthday = str.substr(6, 6);
      return {
        year: `19${birthday.substr(0, 2)}`,
        month: `${birthday.substr(2, 2)}`,
        day: `${birthday.substr(4, 2)}`,
        card: str
      }
    } else if (str.length == 18) {
      birthday = str.substr(6, 8);
      return {
        year: `${birthday.substr(0, 4)}`,
        month: `${birthday.substr(4, 2)}`,
        day: `${birthday.substr(6, 2)}`,
        card: str
      }
    }
    return {
      message: "你输入的不是身份证"
    }
  }
  loading(txt) {//调用加载动画
    let loading = document.getElementsByClassName("common-loading");
    if (loading) {
      for (let i = 0; i < loading.length; i++) {
        loading[i].parentNode.removeChild(loading[i]);
      }
    }
    if (txt == undefined || txt || typeof txt == "number") {
      let loadConstructor = Vue.extend(loadDom); // 返回一个“扩展实例构造器”
      let loading = new loadConstructor({
        el: document.createElement('div') //将Alert组件挂载到新创建的div上
      });
      document.body.appendChild(loading.$el); //把Alert组件的dom添加到body里
      // 加载文字
      loading.txt = txt;
    }
  }
  tip(txt) {//提示窗
      let AlertConstructor = Vue.extend(dialog); // 返回一个“扩展实例构造器”
      let tipDom = document.createElement('div');
      tipDom.innerText = txt;
      tipDom.className = "common-tip";
      document.body.appendChild(tipDom);
      setTimeout(() => {
          tipDom.parentNode.removeChild(tipDom);
      }, 1000);
  }
  alert(o) {//调用公共弹窗
    let inputDom = document.getElementsByTagName('input');
    if (inputDom.length > 0) {
      for (let i = 0; i < inputDom.length; i++) {
        inputDom[i].blur();
      }
    }
    let AlertConstructor = Vue.extend(dialog); // 返回一个“扩展实例构造器”
    let alertDom = new AlertConstructor({
      el: document.createElement('div') //将Alert组件挂载到新创建的div上
    });
    // setTimeout(() => {
    //   window.scrollTo(0, document.body.scrollTop + 0);
    //   document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 0);
    // })
    document.body.appendChild(alertDom.$el); //把Alert组件的dom添加到body里
    // DOM
    alertDom.DOM = alertDom.$el;
    // 标题
    alertDom.TITLE = o.TITLE;
    // 弹窗内容，可传html
    alertDom.CONTENT_HTML = o.CONTENT_HTML || "";
    // 弹窗内容，可传文本
    alertDom.CONTENT = o.CONTENT;
    // 是否显示关闭按钮
    alertDom.SHOW_CLOSE = o.SHOW_CLOSE || false;
    // 是否显示取消按钮
    alertDom.SHOW_CANCEL = o.SHOW_CANCEL || false;
    // 确定按钮是否禁用
    alertDom.DISA_SUBMIT = o.DISA_SUBMIT || false;
    // 取消按钮名称
    alertDom.BTN_CANCEL = o.BTN_CANCEL || "取消";
    // 确定按钮名称
    alertDom.BTN_SUBMIT = o.BTN_SUBMIT || "确定";
    // 取消回调
       
    alertDom.COUNTDOWN = o.COUNTDOWN || 0;
    if(o.COUNTDOWN){
      var itv = setInterval(() => {
        if(alertDom.COUNTDOWN==0){
          clearInterval(itv)
        }else{
          alertDom.COUNTDOWN--
        }
      }, 1000);
    }
    // 关闭回调
    alertDom.BACK_CLOSE = o.BACK_CLOSE || null;
    alertDom.BACK_CANCEL = o.BACK_CANCEL || null;
    // 确定回调
    alertDom.BACK_SUBMIT = o.BACK_SUBMIT || null;
  }
  idcard(id) {//身份证校验位判断
    id = id + ""
    // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if (!format.test(id)) {
      return false;
    }
    //区位码校验
    //出生年月日校验  前正则限制起始年份为1900;
    var year = id.substr(6, 4),//身份证年
      month = id.substr(10, 2),//身份证月
      date = id.substr(12, 2),//身份证日
      time = Date.parse(month + '-' + date + '-' + year),//身份证日期时间戳date
      now_time = Date.parse(new Date()),//当前时间戳
      dates = (new Date(year, month, 0)).getDate();//身份证当月天数
    if (time > now_time || date > dates) {
      return false;
    }
    //校验码判断
    var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);  //系数
    var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'); //校验码对照表
    var id_array = id.split("");
    var sum = 0;
    for (var k = 0; k < 17; k++) {
      sum += parseInt(id_array[k]) * parseInt(c[k]);
    }
    if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
      return false;
    }
    return true;
  }
  buildTreeData(data, id, pid, name, level) {//生成结构数据
    var map = {};
    var val = [];
    let arr = [];
    data.forEach(function (item) {
      delete item.children;
      arr.push({
        id: item[id],
        pid: item[pid],
        value: item[id],
        level: item[level],
        label: item[name],
      })
    });
    data = arr;
    data.forEach(function (item) {
      map[item.id] = item;
    });
    data.forEach(function (item) {
      var parent = map[item.pid];
      if (parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
        val.push(item);
      }
    });
    return val;
  }
  setTopFn(className, value) {//设置fixed定位在底部的高度
      let dom = document.getElementsByClassName(className)[0];
      let docmHeight = window.document.body.offsetHeight;
      dom.style.top = docmHeight - dom.clientHeight - (value || 0) + "px";
  }
}
export default new Training();



// WEBPACK FOOTER //
// ./src/assets/js/training.js